import { render, staticRenderFns } from "./ModalVerHistorico.vue?vue&type=template&id=35f2d055&scoped=true&"
import script from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerHistorico.vue?vue&type=style&index=0&id=35f2d055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2d055",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35f2d055', component.options)
    } else {
      api.reload('35f2d055', component.options)
    }
    module.hot.accept("./ModalVerHistorico.vue?vue&type=template&id=35f2d055&scoped=true&", function () {
      api.rerender('35f2d055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfiguracionAlarmas/ModalVerHistorico.vue"
export default component.exports